import { render, staticRenderFns } from "./EditKeyAccess.vue?vue&type=template&id=504e23be&"
import script from "./EditKeyAccess.vue?vue&type=script&lang=ts&"
export * from "./EditKeyAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports